module.exports = __webpack_public_path__ + "img/data_analysis_bac2.a6f0210a.png";